import paymentInstance from '../instance'
import paymentModalLoginInstance from '../modalLoginInstance'

const getQrPaymentSession = (sessionId, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance)
		.get(`/qrPaymentSessions/${sessionId}`)
}

export default getQrPaymentSession
